export class Locale {
    id:number;
    name: string;
    description:string;
    sortOrder:number;
}
